module.exports = __webpack_public_path__ + "static/media/multi_platform.e42bb266.svg";